import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { ApiRequestDescriptor, executeQuery } from '../../services';

const ENDPOINT = `${APIConfiguration.claim}claimGroups`;

export interface GetFullClaimsByGroupIdQueryArgs {
  claimGroupId: string;
}

export const getFullClaimsByGroupIdRequest = ({
  claimGroupId,
}: GetFullClaimsByGroupIdQueryArgs): ApiRequestDescriptor => ({
  url: `${ENDPOINT}/${claimGroupId}/full`,
  config: { method: SUPPORTED_METHODS.GET },
});

export const getFullClaimsByGroupIdQuery = async (
  args: GetFullClaimsByGroupIdQueryArgs,
): Promise<BackResponse<Record<string, unknown>[]> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<Record<string, unknown>[]>>(
      getFullClaimsByGroupIdRequest(args),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
